import AccountScreenWrapper from './AccountScreenWrapper'

export default AccountScreenWrapper



// WEBPACK FOOTER //
// ./src/containers/core/AccountScreenWrapper/index.js